import Page from "app/components/Page";
import PageHeader from "./components/PageHeader";
import PaymentMethods from "./components/PaymentMethods";

export default function Home() {
  return (
    <Page title={<PageHeader />} noPadding>
      <PaymentMethods />
    </Page>
  );
}
